import type { ChatDto } from '../api/types';
import { setDraft } from './drafts';

/** Черновик всегда адресуется своей переписке, даже у оператора с несколькими isSupport. */
export async function prepareReleaseFeedback(
  userId: string,
  getConversation: () => Promise<ChatDto>,
  text: string,
): Promise<string> {
  const support = await getConversation();
  setDraft(userId, support.id, null, text);
  return support.id;
}
